import React from 'react'

import Card from '../../../../atoms/card/Card'
import InlineGroup from '../../../../atoms/inlinegroup/InlineGroup'
import Clickable from '../../../../atoms/clickable/Clickable'
import Icon from '../../../../atoms/icon/Icon'
import { FinancialSummaryMetricsReadOnly } from './FinancialSummaryMetricsReadOnly'

interface Props {
  data: API.SimulationResponse['financialSummaryMetrics']
  config?: API.SimulationResponse['financialSummaryMetricConfig']
  onClickEdit?: () => void
}

const Display: React.FC<Props> = ({ data, config, onClickEdit }) => {
  return data ? (
    <Card wide>
      <InlineGroup verticalCenter>
        <h4>Financial Summary Screen Settings</h4>
        {
          onClickEdit ? <Clickable
            data-test={'edit-simulation-financial-metrics-step'}
            onClick={onClickEdit}>
            <Icon
              type='edit'
              tip={{
                content: 'Edit Financial Screen Metrics',
                id: 'edit-financial-metrics'
              }}
            />
          </Clickable>
            : null
        }
      </InlineGroup>
      <h4>Metrics List</h4>
      <FinancialSummaryMetricsReadOnly data={data} config={config} />
    </Card>
  ) : null
}

export default Display
